import { Toaster } from '@mdvip/shared/components/ui/toaster';
import { IdleTimeoutManager } from '@mdvip/shared/features/idle-timeout/IdleTimeoutManager';
import { AuthCallbackPage } from '@mdvip/shared/pages/AuthCallbackPage';
import { LoginPage } from '@mdvip/shared/pages/LoginPage';
import { getHealthUrl } from '@mdvip/shared/types/config';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './components/shared/ProtectedRoute';
import { useConfig } from './contexts/ConfigContext';
import { DashboardPage } from './pages/DashboardPage';
import { MembersPage } from './pages/MembersPage';
import { MessagesPage } from './pages/MessagesPage';
import { PracticePage } from './pages/PracticePage';
import { ResourcesPage } from './pages/ResourcesPage';
import { StaffManagementPage } from './pages/StaffManagementPage';

function App() {
  const config = useConfig();

  return (
    <>
      <IdleTimeoutManager
        idleTimeoutMs={config.IDLE_TIMEOUT_MS}
        warningDurationMs={config.WARNING_DURATION_MS}
        tokenRefreshThreshold={config.TOKEN_REFRESH_THRESHOLD}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage healthUrl={getHealthUrl(config)} postLoginRedirect="/" />} />
          <Route path="/auth/callback" element={<AuthCallbackPage postLoginRedirect="/" />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/members"
            element={
              <ProtectedRoute>
                <MembersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <MessagesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/resources"
            element={
              <ProtectedRoute>
                <ResourcesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/staff"
            element={
              <ProtectedRoute>
                <StaffManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/practice"
            element={
              <ProtectedRoute>
                <PracticePage />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </>
  );
}

export default App;
